$(document).ready(() => {
    // =====COMMON CLICK EVENTS AND DROPDOWNS=====
    const toggleDropDownAndSortingFilter = () => {
        $(document).on("click", "button.dropDownOpener", function () {
            $(".customDropDown")
            .not($(this).parent(".customDropDown"))
            .removeClass("activeDropDown");
            $(".dropDownContent").not($(this).next(".dropDownContent")).slideUp(200);
            $(this).parent(".customDropDown").toggleClass("activeDropDown");
            $(this).next(".dropDownContent").slideToggle(400);
        });

        $(document).on("click", "button.sortSelector", function () {
            var $thisText = $(this).text();
            var filterValue = $(this).attr("data-filter");

            // ⭐ REMOVE active class from all options
            $(".sortSelector").removeClass("activeSort");

            // ⭐ ADD active class to clicked option
            $(this).addClass("activeSort");

            // update dropdown label
            $(this)
                .parent(".dropDownContent")
                .prev(".dropDownOpener")
                .children("span")
                .text($thisText);

            // if ($(".faceted-filter-form").length > 0) {
            //     $(".faceted-filter-form").slideUp(200);
            // }
            $(".dropDownContent").slideUp(200);

            if ($("#sort-by").length > 0) {
                $("#sort-by").val(filterValue).change();
            }
        });

    };
    
    // Close Sort By dropdown if clicked outside
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".customDropDown").length) {
            $(".customDropDown").removeClass("activeDropDown");
            $(".dropDownContent").slideUp(200);
        }
    });

    
    $(document).on("click", ".backToSecondLevel", function () {
      $(".mega-sub.level3").removeClass("is-open-l3");
    });
    $(document).on("click", ".backToFirstLevel", function () {
      $(".mega-sub.level2").removeClass("is-open-l2").hide();
    });
    $(document).on("click", ".backToMainMenu", function () {
    //   $(".mobile-submenu__list").hide();
      $(".submenu__input").prop("checked", false); // uncheck all
    });

    toggleDropDownAndSortingFilter();
});

$(document).ready(function () {
    let params = new URLSearchParams(window.location.search);
    let currentSort = params.get("sort_by");

    if (currentSort) {
        // User-selected sort → highlight + update label
        $(".sortSelector").removeClass("activeSort");
        var activeBtn = $('.sortSelector[data-filter="' + currentSort + '"]');
        activeBtn.addClass("activeSort");

        var activeText = activeBtn.text().trim();
        $(".dropDownOpener span").text(activeText);
    } 
    else {
        // No sort selected → use default label
        $(".dropDownOpener span").text("Sort By");

        // Remove highlight from all
        $(".sortSelector").removeClass("activeSort");
    }
});

var textSlider = null;

function initTextSlider() {
  var elem = document.querySelector('.text_column_wrapper');
  if (!elem) return;

  var mobile = window.innerWidth <= 768;

  if (mobile && !textSlider) {
    textSlider = new Flickity(elem, {
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,
        arrowShape: arrowShape
    });
  }
  

  if (!mobile && textSlider) {
    textSlider.destroy();
    textSlider = null;
  }
}

// init on load
document.addEventListener('DOMContentLoaded', initTextSlider);

// re-init on resize
window.addEventListener('resize', initTextSlider);

